import { Country, State } from 'country-state-city'
import { sortBy } from 'lodash'

interface FirmographicSelectOption {
  label?: string
  value?: string
  options?: FirmographicSelectOption[]
}

interface CountryISOFormat {
  isoCode: string
  name: string
  options?: any[]
}

// https://github.com/lukes/ISO-3166-Countries-with-Regional-Codes/blob/master/all/all.csv
export const COUNTRY_NAMES = [
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  "Côte d'Ivoire",
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea, Democratic People's Republic of",
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, the Former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe'
].sort()

export const INDUSTRIES = [
  'Accounting',
  'Advertising',
  'Advertising & Marketing',
  'Aerospace & Defense',
  'Agency',
  'Agriculture',
  'Automotive',
  'Banking',
  'Biotechnology',
  'Business Services',
  'Chemicals',
  'Communications',
  'Communications, Media and Services',
  'Computer Software',
  'Construction',
  'Consulting',
  'Consulting & Professional Services',
  'Consulting and Technology',
  'Consumer Goods',
  'Consumer Products',
  'Consumer Services',
  'Corporate Services',
  'Education',
  'Education Services',
  'Electronics',
  'Energy',
  'Energy & Utilities',
  'Energy, Utilities & Waste',
  'Engineering',
  'Entertainment',
  'Finance',
  'Financial Services',
  'Food & Beverage',
  'Government',
  'HE - High Tech & Electronics',
  'Health Care',
  'Healthcare',
  'Healthcare Services',
  'High Tech',
  'High Technology',
  'Higher Education',
  'Hospitality',
  'Hospitals / Health Care',
  'Hospitals & Physicians Clinics',
  'Industrial Manufacturing',
  'Information and Cultural Products',
  'Information Technology',
  'Information Technology and Services',
  'Insurance',
  'Internet',
  'Internet Software & Services',
  'IT Services',
  'Law Firms & Legal Services',
  'Legal',
  'Legal Services',
  'Life Sciences',
  'Machinery',
  'Manufacturing',
  'Manufacturing - Durables',
  'Manufacturing & Industrial',
  'Marketing and Advertising',
  'Media',
  'Media & Entertainment',
  'Media & Internet',
  'Media and Telecommunications',
  'Metal Former',
  'Non-Profit',
  'Non-profit',
  'Non-Profits',
  'Not For Profit',
  'Not for Profit & Faith Based',
  'Oil & Gas',
  'Organizations',
  'Other',
  'Pharmaceuticals',
  'Professional & Business Services',
  'Professional & Legal Services',
  'Professional and Technical Services',
  'Professional Services',
  'Professional, Scientific & Technical Svc',
  'Public Sector',
  'Real Estate',
  'Real Estate & Construction',
  'Residential Custom Builder',
  'Retail',
  'Services',
  'Software',
  'Software & Internet',
  'Software and Technology',
  'Software General',
  'State & Local Government',
  'Technology',
  'Telecommunications',
  'Transportation',
  'Transportation & Logistics',
  'Utilities',
  'Wholesale',
  'Wholesale & Distribution',
  'Wholesale & Retail',
  'Wholesale Trade'
].sort()

export const generateSelectOptions = (options: string[]): FirmographicSelectOption[] =>
  options.map(option => ({
    value: option,
    label: option
  }))

export const COUNTRY_SELECT_OPTIONS = generateSelectOptions(COUNTRY_NAMES)
export const INDUSTRY_SELECT_OPTIONS = generateSelectOptions(INDUSTRIES)

export const STATE_SELECT_OPTIONS = (): FirmographicSelectOption[] =>
  Country.getAllCountries().reduce((acc: FirmographicSelectOption[], country: CountryISOFormat) => {
    const whitelisted = COUNTRY_NAMES.includes(country.name)
    let countriesIdx = -1

    const countries =
      acc.find(({ label }: { label?: string } = {}, idx: number) => {
        if (label === 'Countries') {
          countriesIdx = idx
          return true
        }
        return false
      }) || {}
    let returnVal: FirmographicSelectOption[] = [...acc]

    if (countriesIdx > -1) {
      returnVal.splice(countriesIdx, 1)
      returnVal[countriesIdx] = {
        ...countries,
        options: [
          ...(countries.options as FirmographicSelectOption[]),
          { label: country.name, value: `-${country.isoCode}` }
        ]
      }
    } else {
      returnVal = [
        ...returnVal,
        {
          label: 'Countries',
          options: [{ label: country.name, value: `-${country.isoCode}` }]
        }
      ]
    }

    if (whitelisted) {
      returnVal = [
        ...returnVal,
        {
          label: country.name,
          options: State.getStatesOfCountry(country.isoCode).map(state => ({
            label: state.name,
            value: `${state.name}`
          }))
        }
      ]
    }

    return sortBy(returnVal, ({ label }) => (label === 'United States' ? 0 : 1))
  }, [])

export const ENGAGEMENT_SCORES_COLORS = {
  1: '#92C6FE',
  2: '#92C6FE',
  3: '#FECC3A',
  4: '#C66F2F',
  5: '#C7291B'
} as const

export const EMPLOYEE_COUNTS_BY_RANGE_NAME: { [key: string]: string } = {
  "Micro/No touch": "1-10",
  "Small": "11-50",
  "Mid-size": "51-200",
  "Large": "201-1000",
  "Enterprise": "1001+"
}

export type AccountFitSettings =  Record<string, string[]>